<div class="pt-4 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_members">
  <h2>You do not have permission to manage this inbox.</h2>
</div>

<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4">
  <div class="row">
    <div class="col">
      <p class="text-center w-100"><b>
        Linking Account Requests
        <span *ngIf="relationRequests">({{ relationRequests.length }})</span>
      </b></p>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Requesting Customer Name</th>
        <th scope="col">Related Customer Name</th>
        <th scope="col">Relation</th>
        <th scope="col">Requested Date</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingRelationRequests && relationRequestsPresent()">
      <tr *ngFor="let relationRequest of relationRequests">
        <td>
          <a [routerLink]="['/customers', relationRequest.requesting_customer_id.toString()]" target="_blank">
            {{ relationRequest.requesting_customer_first_name }} {{ relationRequest.requesting_customer_last_name }}
          </a>
        </td>
        <td>
          <a [routerLink]="['/customers', relationRequest.related_customer_id.toString()]" target="_blank">
            {{ relationRequest.related_customer_first_name }} {{ relationRequest.related_customer_last_name }}
          </a>
        </td>
        <td>
          {{ getRelationTypeDisplay(relationRequest.relation) }}
        </td>
        <td>
          {{ dateStringFromISO8601(relationRequest.created_at) }}
        </td>
        <td class="table-btn-sm text-right">
          <button class="btn btn-outline-primary btn-sm" style="min-width: 120px"
                  (click)="openReviewPendingLinkedAccountModal(relationRequest);$event.preventDefault();">
            Review
          </button>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingRelationRequests || !relationRequestsPresent()">
      <tr>
        <td colspan="99" *ngIf="loadingRelationRequests">
          Loading...
        </td>
        <td colspan="99" *ngIf="!loadingRelationRequests && !relationRequestsPresent()">
          No outstanding linking account requests.
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</div>

<div class="pt-4 pl-md-4 mb-6">
  <div class="row">
    <div class="col">
      <p class="text-center w-100"><b>
        Unmatched Linking Account Requests
      </b></p>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Requesting Customer Name</th>
        <th scope="col">Related Customer Name</th>
        <th scope="col">Related Customer Birthday</th>
        <th scope="col">Relation</th>
        <th scope="col">Requested Date</th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingUnmatchedLinkRequestLogs && unmatchedLinkRequestLogsPresent()">
      <tr *ngFor="let unmatchedLinkRequestLog of unmatchedLinkRequestLogs">
        <td>
          <a [routerLink]="['/customers', unmatchedLinkRequestLog.requesting_customer_id.toString()]" target="_blank">
          {{ unmatchedLinkRequestLog.requesting_customer_first_name }}
          {{ unmatchedLinkRequestLog.requesting_customer_last_name }}
          </a>
        </td>
        <td>
          {{ unmatchedLinkRequestLog.first_name_input }}
          {{ unmatchedLinkRequestLog.last_name_input }}
        </td>
        <td>
          {{ dateStringFromISO8601(unmatchedLinkRequestLog.birthday_input) }}
        </td>
        <td>
          {{ getRelationTypeDisplay(unmatchedLinkRequestLog.relation_input) }}
        </td>
        <td>
          {{ dateStringFromISO8601(unmatchedLinkRequestLog.created_at) }}
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingUnmatchedLinkRequestLogs || !unmatchedLinkRequestLogsPresent()">
      <tr>
        <td colspan="99" *ngIf="loadingUnmatchedLinkRequestLogs">
          Loading...
        </td>
        <td colspan="99" *ngIf="!loadingUnmatchedLinkRequestLogs && !unmatchedLinkRequestLogsPresent()">
          No unmatched link requests.
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</div>
